import { useState } from "react";
import styles from "./OnlinePortal.module.scss";

const OnlinePortal = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const data = [
    {
      title: "Suggestions",
      header:
        "Suggestions are contacts suggested to you out of the Master List. i.e., family, friends, mechitunim, etc.",
      subHeader: "",
      svg: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 13V15M10 9V15M14 5V15M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
            stroke="#667085"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      items: [
        {
          value:
            "User views his suggestion list and accepts or rejects each record.",
          lines: [
            "User can also select Accept All",
            "User can also filter by specific suggestion categories & relations and Accept the respective results.",
          ],
        },
        {
          value:
            "Every accepted contact appears on his personal listing, called My Contacts.",
          lines: [],
        },
        {
          value: "Contacts are automatically grouped properly.",
          lines: [
            "There are three main groups, Family, Mechitunim, Others",
            "Each main group also has a few sub-groups with specific labels for family names. (Mother’s, father’s, Mother-in-law’s, father-in-law’s, etc.)",
          ],
        },
        {
          value:
            "The user can also create as many of his own groups and sub-groups.",
          lines: [],
        },
      ],
    },

    {
      title: "Master List",
      header:
        "The Master List includes all contacts we have listed in our system.",
      subHeader:
        "The user can select preferred contacts from the Master List by choosing from any of the powerful search tools and filters available:",
      footer:
        "When searching through the master list, every contact that is already in the user’s My Contact list or in the Suggestions list will have a color indicator.",
      svg: (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.0505 7.5H3.5C2.11929 7.5 1 6.38071 1 5C1 3.61929 2.11929 2.5 3.5 2.5H13.0505M6.94949 18.5H16.5C17.8807 18.5 19 17.3807 19 16C19 14.6193 17.8807 13.5 16.5 13.5H6.94949M1 16C1 17.933 2.567 19.5 4.5 19.5C6.433 19.5 8 17.933 8 16C8 14.067 6.433 12.5 4.5 12.5C2.567 12.5 1 14.067 1 16ZM19 5C19 6.933 17.433 8.5 15.5 8.5C13.567 8.5 12 6.933 12 5C12 3.067 13.567 1.5 15.5 1.5C17.433 1.5 19 3.067 19 5Z"
            stroke="#667085"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      items: [
        {
          value: (
            <span className={`fw500 fs18`}>
              Use our Map feature where the customer can draw a circle, and it
              will return all contacts residing within that location. One can
              also simply enter a range of addresses on a given street and it
              will generate the relevant results.
            </span>
          ),
          lines: [],
        },
        {
          value: (
            <span className={`fw500 fs18`}>
              Filter by Region / Zip code / Last Name, etc.
            </span>
          ),
          lines: [],
        },
        {
          value: <span className={`fw500 fs18`}>Filter alphabetically</span>,
          lines: [],
        },
        {
          value: (
            <span className={`fw500 fs18`}>
              Group master contact list by last name. This feature is useful
              when reviewing a large number of contacts.
            </span>
          ),
          lines: [],
        },
      ],
    },
    {
      title: "Contacts management",
      header: "",
      subHeader: "",
      svg: (
        <svg
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 8L7 8M19 2L7 2M19 14L7 14M3 8C3 8.55228 2.55228 9 2 9C1.44772 9 1 8.55228 1 8C1 7.44772 1.44772 7 2 7C2.55228 7 3 7.44772 3 8ZM3 2C3 2.55228 2.55228 3 2 3C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1C2.55228 1 3 1.44772 3 2ZM3 14C3 14.5523 2.55228 15 2 15C1.44772 15 1 14.5523 1 14C1 13.4477 1.44772 13 2 13C2.55228 13 3 13.4477 3 14Z"
            stroke="#667085"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      items: [
        {
          value: "Add Contacts Manually",
          lines: [
            "For contacts that are not in our master database, user can manually enter them either by our contact entry form, or by uploading an excel spreadsheet.",
            "Our system will attempt to match each uploaded contact with its respective contact already in our database, so you can benefit from our services, i.e. future address updates, phone numbers, parental information and more.",
          ],
        },

        {
          value: "Enter Phonebook ID's",
          lines: [
            "Another way to enter contacts, is to enter ID numbers from a community phonebook (currently limited to the Satmar Directory) and the system will automatically enter the respective contact to the My Contact List.",
            "When entering phonebook ID’s user has an option to change titles, and to add a suffix to individual contacts. e.g. & Family",
          ],
        },

        {
          value: "Editing My Contacts",
          lines: [
            "Every name listed in the Master List has a default title, i.e. Mr. & Mrs., Mrs. only (if a widow) Rabbi, etc. The user will have an option to change the title for every contact.",
            "When sending invitations to a contact, one may want to include one child or invite the whole family as well. The user can edit this info by adding a suffix to the contact i.e. & Family.",
            "There is also the ability  to modify the spelling of any contact’s first or last name, address and so forth.",
          ],
        },
      ],
    },
    {
      title: "Sophistication",
      header: "",
      subHeader: "",
      svg: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H13.2C14.8802 19 15.7202 19 16.362 18.673C16.9265 18.3854 17.3854 17.9265 17.673 17.362C18 16.7202 18 15.8802 18 14.2V11M11 15H5M13 11H5M18.1213 1.87868C19.2929 3.05025 19.2929 4.94975 18.1213 6.12132C16.9497 7.29289 15.0503 7.29289 13.8787 6.12132C12.7071 4.94975 12.7071 3.05025 13.8787 1.87868C15.0503 0.707107 16.9497 0.707107 18.1213 1.87868Z"
            stroke="#667085"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      items: [
        {
          value: (
            <span className={`fw500 fs18`}>
              We constantly introduce updates and additions. When we update an
              address or a phone number, (many thousand per year), it will reflect for every user.
            </span>
          ),
          lines: [],
        },
      {
          value: (
            <span className={`fw500 fs18`}>
              Each time a user returns to their list, they will see all new
              suggestions available to them since the last time they visited.
              (i.e. Family/mechitunim additions, newly discovered potential
              contacts, etc.)
            </span>
          ),
          lines: [],
        },       
        {
          value: (
            <span className={`fw500 fs18`}>
              We also developed an algorithm that enables a user to upload his
              own excel file of contacts, and the system will attempt to
              auto-detect its respective entries in our database, save them, and
              update accordingly.
            </span>
          ),
          lines: [],
        },
             {
          value: (
            <span className={`fw500 fs18`}>
             When uploading an excel file, if there are contacts in the file which their address was changed, the system will detect them and automatically update them with their new addresses.
            </span>
          ),
          lines: [],
        },
        {
          value: (
            <span className={`fw500 fs18`}>
              The user will also have the ability to report changes
              (address/phone changes, family link changes, etc.) Changes will
              take effect immediately for the user, and if approved by us, will
              be made public.
            </span>
          ),
          lines: [],
        },
        {
          value: (
            <span className={`fw500 fs18`}>
              All addresses are run through the USPS database for accuracy.
            </span>
          ),
          lines: [],
        },
      ],
    },
    {
      title: "Checkout",
      header:
        "When contacts list is built and organized in groups, user selects all contacts or groups of contacts, enters them into Cart to create an order.",
      subHeader: "",
      footer:
        "We do NOT offer Excel exports. If there is a specific need, they may contact our office.",
      svg: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z"
            stroke="#667085"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.7273 13.7273C17.6063 14.0015 17.5702 14.3056 17.6236 14.6005C17.6771 14.8954 17.8177 15.1676 18.0273 15.3818L18.0818 15.4364C18.2509 15.6052 18.385 15.8057 18.4765 16.0265C18.568 16.2472 18.6151 16.4838 18.6151 16.7227C18.6151 16.9617 18.568 17.1983 18.4765 17.419C18.385 17.6397 18.2509 17.8402 18.0818 18.0091C17.913 18.1781 17.7124 18.3122 17.4917 18.4037C17.271 18.4952 17.0344 18.5423 16.7955 18.5423C16.5565 18.5423 16.3199 18.4952 16.0992 18.4037C15.8785 18.3122 15.678 18.1781 15.5091 18.0091L15.4545 17.9545C15.2403 17.745 14.9682 17.6044 14.6733 17.5509C14.3784 17.4974 14.0742 17.5335 13.8 17.6545C13.5311 17.7698 13.3018 17.9611 13.1403 18.205C12.9788 18.4489 12.8921 18.7347 12.8909 19.0273V19.1818C12.8909 19.664 12.6994 20.1265 12.3584 20.4675C12.0174 20.8084 11.5549 21 11.0727 21C10.5905 21 10.1281 20.8084 9.78708 20.4675C9.4461 20.1265 9.25455 19.664 9.25455 19.1818V19.1C9.24751 18.7991 9.15011 18.5073 8.97501 18.2625C8.79991 18.0176 8.55521 17.8312 8.27273 17.7273C7.99853 17.6063 7.69437 17.5702 7.39947 17.6236C7.10456 17.6771 6.83244 17.8177 6.61818 18.0273L6.56364 18.0818C6.39478 18.2509 6.19425 18.385 5.97353 18.4765C5.7528 18.568 5.51621 18.6151 5.27727 18.6151C5.03834 18.6151 4.80174 18.568 4.58102 18.4765C4.36029 18.385 4.15977 18.2509 3.99091 18.0818C3.82186 17.913 3.68775 17.7124 3.59626 17.4917C3.50476 17.271 3.45766 17.0344 3.45766 16.7955C3.45766 16.5565 3.50476 16.3199 3.59626 16.0992C3.68775 15.8785 3.82186 15.678 3.99091 15.5091L4.04545 15.4545C4.25503 15.2403 4.39562 14.9682 4.4491 14.6733C4.50257 14.3784 4.46647 14.0742 4.34545 13.8C4.23022 13.5311 4.03887 13.3018 3.79497 13.1403C3.55107 12.9788 3.26526 12.8921 2.97273 12.8909H2.81818C2.33597 12.8909 1.87351 12.6994 1.53253 12.3584C1.19156 12.0174 1 11.5549 1 11.0727C1 10.5905 1.19156 10.1281 1.53253 9.78708C1.87351 9.4461 2.33597 9.25455 2.81818 9.25455H2.9C3.2009 9.24751 3.49273 9.15011 3.73754 8.97501C3.98236 8.79991 4.16883 8.55521 4.27273 8.27273C4.39374 7.99853 4.42984 7.69437 4.37637 7.39947C4.3229 7.10456 4.18231 6.83244 3.97273 6.61818L3.91818 6.56364C3.74913 6.39478 3.61503 6.19425 3.52353 5.97353C3.43203 5.7528 3.38493 5.51621 3.38493 5.27727C3.38493 5.03834 3.43203 4.80174 3.52353 4.58102C3.61503 4.36029 3.74913 4.15977 3.91818 3.99091C4.08704 3.82186 4.28757 3.68775 4.50829 3.59626C4.72901 3.50476 4.96561 3.45766 5.20455 3.45766C5.44348 3.45766 5.68008 3.50476 5.9008 3.59626C6.12152 3.68775 6.32205 3.82186 6.49091 3.99091L6.54545 4.04545C6.75971 4.25503 7.03183 4.39562 7.32674 4.4491C7.62164 4.50257 7.9258 4.46647 8.2 4.34545H8.27273C8.54161 4.23022 8.77093 4.03887 8.93245 3.79497C9.09397 3.55107 9.18065 3.26526 9.18182 2.97273V2.81818C9.18182 2.33597 9.37338 1.87351 9.71435 1.53253C10.0553 1.19156 10.5178 1 11 1C11.4822 1 11.9447 1.19156 12.2856 1.53253C12.6266 1.87351 12.8182 2.33597 12.8182 2.81818V2.9C12.8193 3.19253 12.906 3.47834 13.0676 3.72224C13.2291 3.96614 13.4584 4.15749 13.7273 4.27273C14.0015 4.39374 14.3056 4.42984 14.6005 4.37637C14.8954 4.3229 15.1676 4.18231 15.3818 3.97273L15.4364 3.91818C15.6052 3.74913 15.8057 3.61503 16.0265 3.52353C16.2472 3.43203 16.4838 3.38493 16.7227 3.38493C16.9617 3.38493 17.1983 3.43203 17.419 3.52353C17.6397 3.61503 17.8402 3.74913 18.0091 3.91818C18.1781 4.08704 18.3122 4.28757 18.4037 4.50829C18.4952 4.72901 18.5423 4.96561 18.5423 5.20455C18.5423 5.44348 18.4952 5.68008 18.4037 5.9008C18.3122 6.12152 18.1781 6.32205 18.0091 6.49091L17.9545 6.54545C17.745 6.75971 17.6044 7.03183 17.5509 7.32674C17.4974 7.62164 17.5335 7.9258 17.6545 8.2V8.27273C17.7698 8.54161 17.9611 8.77093 18.205 8.93245C18.4489 9.09397 18.7347 9.18065 19.0273 9.18182H19.1818C19.664 9.18182 20.1265 9.37338 20.4675 9.71435C20.8084 10.0553 21 10.5178 21 11C21 11.4822 20.8084 11.9447 20.4675 12.2856C20.1265 12.6266 19.664 12.8182 19.1818 12.8182H19.1C18.8075 12.8193 18.5217 12.906 18.2778 13.0676C18.0339 13.2291 17.8425 13.4584 17.7273 13.7273Z"
            stroke="#667085"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      items: [
        {
          value:
            "We are currently offering the following services to our customers.",
          lines: [
            <p>
              <span className={`fw700 ${styles.liBold}`}>
                Self-service mailing.
              </span>
              Users will be able to create a printable file with labels made
              from a template we provide and printed by the user himself. The
              list can be created based on his entire My Contact list, specific
              group/s, or individual contacts selected.
            </p>,
            <p>
              <span className={`fw700 ${styles.liBold}`}>
                Company-provided mailing.
              </span>
              The user will submit their job to be professionally printed by us.
              We offer various types of labels and sizes, as well as directly
              printing addresses on envelopes.  We also offer a complete
              start-to-finish job from stuffing to stamping and mailing.
            </p>,
            <p>
              <span className={`fw700 ${styles.liBold}`}>Phone calls.</span>
              The user will be able to send out a voice call to his selected
              contact list. He can schedule a date and time for the call and set
              the message by either recording on the computer, uploading a
              pre-recorded message, or type his text which we convert to speech.
            </p>,
            <p>
              <span className={`fw700 ${styles.liBold}`}>Text Messages.</span>
              These can be scheduled for a specific date and time.
            </p>,
            <p>
              <span className={`fw700 ${styles.liBold}`}>PDF List.</span>
              Get the selected contacts with all details in the format of a
              phone book.
            </p>,
            <p>
              <span className={`fw700 ${styles.liBold}`}>Mass Emails.</span>
              Coming soon.
            </p>,
          ],
        },
      ],
    },
  ];
  return (
    <div className={`${styles.portal}`}>
      <h4 className={`ffm fs30 fw700 tac c084571`}>Our online portal</h4>
      <p className={`ffm fs20 fw500 tac c084571`}>
        When a customer logs in, he will automatically get a list of suggested
        contacts.
      </p>

      <div className={styles.itemsList}>
        <div className={`bc084571 cfff ffm ${styles.sec}`}>
          <h5 className={`fs20 fw700`}>Family</h5>
          <p className={`fs17 fw500`}>
            Users can configure how many extended generations to search through
            their family, which can be done individually for each of their 4
            family sides: Father / Mother / Father-in-law / Mother-in-law
          </p>
        </div>
        <div className={`bc084571 cfff ffm ${styles.sec}`}>
          <h5 className={`fs20 fw700`}>Mechitunim</h5>
          <p className={`fs17 fw500`}>
            Users can configure how far to search through their own in-laws,
            their parents' in-laws, etc.
          </p>
        </div>
        <div className={`bc084571 cfff ffm ${styles.sec}`}>
          <h5 className={`fs20 fw700`}>Friends</h5>
          <p className={`fs17 fw500`}>
            Suggested friends are calculated using sophisticated algorithms.
            These suggestions include contacts that have a probability of being
            your friend or close acquaintance.{" "}
          </p>
        </div>
      </div>

      <div className={`df ${styles.acc} ${styles.desktop}`}>
        <div className={styles.list}>
          <p className={`ffm fs22 fw700 c084571 ${styles.hdr}`}>How to start</p>
          {data.map((op, idx) => {
            return (
              <div
                className={`df aic ffi fs16 fw600 c344054 ${styles.op} ${
                  selectedTab === idx ? styles.selected : undefined
                }`}
                onClick={() => setSelectedTab(idx)}
              >
                <div className={`df acc ${styles.svgWrapper}`}>{op.svg}</div>
                <p className={styles.title}>{op.title}</p>
              </div>
            );
          })}
        </div>

        <div className={styles.items}>
          {/* {data[selectedTab].header ? ( */}
          <p className={`ffm fs20 fw500 c084571 ${styles.secHdr}`}>
            <span className={`fw700`}>{data[selectedTab].title}:</span>{" "}
            {data[selectedTab].header}
          </p>
          {/* ) : undefined} */}

          {data[selectedTab].subHeader ? (
            <p className={`ffm fs16 fw500 c084571 ${styles.subHeader}`}>
              {data[selectedTab].subHeader}
            </p>
          ) : undefined}

          <ul className={styles.itemUl}>
            {data[selectedTab].items.map((item) => {
              return (
                <li className={`ffm fs20 fw600 c084571`}>
                  <li>{item.value}</li>
                  {item.lines?.length ? (
                    <ul className={styles.lineUl}>
                      {item.lines.map((line) => {
                        return (
                          <li className={`ffm fs18 fw500 c084571`}>{line}</li>
                        );
                      })}
                    </ul>
                  ) : undefined}
                </li>
              );
            })}
          </ul>
          <p className={`ffm fs14 fw500 c084571 ${styles.footer}`}>
            {data[selectedTab].footer}
          </p>
        </div>
      </div>

      <div className={`df ${styles.acc} ${styles.mobile}`}>
        <div className={styles.list}>
          {/* <p className={`ffm fs22 fw700 c084571 ${styles.hdr}`}>How to start</p> */}
          {data.map((op, idx) => {
            return (
              <>
                <div
                  className={`df aic ffi fs16 fw600 c344054 ${styles.op} ${
                    selectedTab === idx ? styles.selected : undefined
                  }`}
                  onClick={() => setSelectedTab(idx)}
                >
                  <div className={`df acc ${styles.svgWrapper}`}>{op.svg}</div>
                  <p className={styles.title}>{op.title}</p>
                </div>
                {selectedTab === idx ? (
                  <div className={styles.items}>
                    <p className={`ffm fs20 fw500 c084571 ${styles.secHdr}`}>
                      <span className={`fw700`}>{data[idx].title}:</span>{" "}
                      {data[idx].header}
                    </p>

                    {data[idx].subHeader ? (
                      <p
                        className={`ffm fs16 fw500 c084571 ${styles.subHeader}`}
                      >
                        {data[idx].subHeader}
                      </p>
                    ) : undefined}

                    <ul className={styles.itemUl}>
                      {data[idx].items.map((item) => {
                        return (
                          <li className={`ffm fs20 fw600 c084571`}>
                            <li>{item.value}</li>
                            {item.lines?.length ? (
                              <ul className={styles.lineUl}>
                                {item.lines.map((line) => {
                                  return (
                                    <li className={`ffm fs18 fw500 c084571`}>
                                      {line}
                                    </li>
                                  );
                                })}
                              </ul>
                            ) : undefined}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : undefined}
              </>
            );
          })}
        </div>

        {/* <div className={styles.items}>
         
          <p className={`ffm fs20 fw500 c084571 ${styles.secHdr}`}>
            <span className={`fw700`}>{data[selectedTab].title}:</span>{" "}
            {data[selectedTab].header}
          </p>
        

          {data[selectedTab].subHeader ? (
            <p className={`ffm fs16 fw500 c084571 ${styles.subHeader}`}>
              {data[selectedTab].subHeader}
            </p>
          ) : undefined}

          <ul className={styles.itemUl}>
            {data[selectedTab].items.map((item) => {
              return (
                <li className={`ffm fs20 fw600 c084571`}>
                  <li>{item.value}</li>
                  {item.lines?.length ? (
                    <ul className={styles.lineUl}>
                      {item.lines.map((line) => {
                        return (
                          <li className={`ffm fs18 fw500 c084571`}>{line}</li>
                        );
                      })}
                    </ul>
                  ) : undefined}
                </li>
              );
            })}
          </ul>
          <p className={`ffm fs14 fw500 c084571 ${styles.footer}`}>
            {data[selectedTab].footer}
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default OnlinePortal;
